import feathersClient from '../../feathers-client';

export default {
	actions:{
		getAppVersion: async ({rootGetters}) => {
			const result = await feathersClient.service('api/v3/get-application-versions').find({}).catch((err)=>{
				console.log('Errorn on get application',err);
			});
			return result;
		}
	}
}
